export class BackupPostureControlRules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "minimumRetention",
            "baseName": "minimumRetention",
            "type": "Array<MinRetentionRule>",
            "format": ""
        },
        {
            "name": "maximumRetention",
            "baseName": "maximumRetention",
            "type": "MaxRetentionRule",
            "format": ""
        },
        {
            "name": "numberOfCopies",
            "baseName": "numberOfCopies",
            "type": "NumberOfCopiesRule",
            "format": ""
        },
        {
            "name": "crossRegion",
            "baseName": "crossRegion",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "crossAccount",
            "baseName": "crossAccount",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "crossCloudProvider",
            "baseName": "crossCloudProvider",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPostureControlRules.attributeTypeMap;
    }
    constructor() {
    }
}
